import React, { Component } from "react";
import { Form, Input, Button, Card } from "reactstrap";
import { postData } from "../utils/fetch-requests";

class ResetPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      confirmPassword: "",
      tokenValid: null, // null = checking, true/false once known
      error: "",
      done: false,
    };
  }

  componentDidMount() {
    fetch("/api/user/reset-password/" + this.props.token + "/validate")
      .then((res) => res.json())
      .then((res) => {
        this.setState({ tokenValid: !!(res && res.valid) });
      })
      .catch(() => {
        this.setState({ tokenValid: false });
      });
  }

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  submit = () => {
    const { password, confirmPassword } = this.state;
    if (password.length < 8) {
      this.setState({ error: "Password must be at least 8 characters." });
      return;
    }
    if (password !== confirmPassword) {
      this.setState({ error: "Passwords do not match." });
      return;
    }
    this.setState({ error: "" });

    postData("/api/user/reset-password", {
      token: this.props.token,
      password,
    })
      .then((res) => {
        if (res && res.status === 200) {
          this.setState({ done: true });
        } else {
          this.setState({
            error: (res && res.message) || "Unable to reset password.",
          });
        }
      })
      .catch(() => {
        this.setState({ error: "Unable to reset password. Please try again." });
      });
  };

  renderBody() {
    if (this.state.tokenValid === null) {
      return <h5 className="text-muted">Checking your reset link...</h5>;
    }

    if (this.state.done) {
      return (
        <div>
          <h5 className="text-muted">Your password has been reset.</h5>
          <a href="/login">Continue to login</a>
        </div>
      );
    }

    if (!this.state.tokenValid) {
      return (
        <div>
          <h5 className="text-muted">
            This reset link is invalid or has expired.
          </h5>
          <a href="/forgot-password">Request a new link</a>
        </div>
      );
    }

    return (
      <div>
        <h5 className="text-muted">Choose a new password.</h5>
        <Form>
          <Input
            id="password"
            className="form-control mb-1"
            placeholder="New password"
            type="password"
            value={this.state.password}
            onChange={this.handleChange}
          />
          <Input
            id="confirmPassword"
            className="form-control mb-1"
            placeholder="Confirm new password"
            type="password"
            value={this.state.confirmPassword}
            onChange={this.handleChange}
          />
        </Form>
        {this.state.error && (
          <p className="text-danger mb-1">{this.state.error}</p>
        )}
        <Button className="ryno-orange-bg" block onClick={this.submit}>
          Reset password
        </Button>
      </div>
    );
  }

  render() {
    return (
      <div className="d-flex h-100 justify-content-center justify-content-middle text-center">
        <div className="col-md-3" style={{ marginTop: "10%" }}>
          <Card className="p-3 card-shadow">
            <div className="align-self-center">
              <img
                src="https://cdn.rynoss.com/wp-content/themes/rynoss/assets/images/RYNOSS-logo.png"
                alt=""
              />
            </div>
            <div className="col-12">{this.renderBody()}</div>
          </Card>
        </div>
      </div>
    );
  }
}

export default ResetPasswordPage;
